import React, { Component } from 'react';
import { Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import moment from 'moment';
import styled from 'styled-components';
import {
  HHDatePicker,
  HHSingleSelect,
  HHContentEditor,
  HHFileUploader
} from './fields';
import HHSingleSelectLightBtn from './fields/hhSingleSelectLightBtn';
import { ThemeMultipleSelect } from './fields/themeMultipleSelect';
import CreateEventQuitModal from '../events/components/createEventQuitModal';
import Image from '../common/image';

const FormHeader = styled.div`
  font-family: 'Inter';
  font-weight: 900;
  font-size: 24px;
  line-height: 29.05px;
  font-style: normal;
  color: #333333;
  padding-bottom: 30px;
`;

const FormSubHeader = styled.div`
  font-family: 'Inter';
  font-weight: 500;
  font-size: 24px;
  line-height: 29.05px;
  font-style: normal;
  color: #333333;
  padding-bottom: 24px;
  padding-top: 15px;
`;

const FieldsContent = styled.div`
  display: grid;
  padding-left: 37px;
`;

const FieldsHeader = styled.div`
  padding-bottom: 8px;
`;

const FieldsHelpText = styled.p`
  color: #A4A4A4;
  font-family: 'Inter';
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  padding-bottom: 8px;
`;

const FieldsHeaderText = styled.p`
  display: inline-block;
  font-family: 'Quicksand';
  font-size: 20px;
  line-height: 25px;
  font-weight: 500;
  color: #222C5E;
`;

const FieldsOrderNumber = styled.div`
  display: inline-block;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 3.7px;

  background: #0F70BC;
  border: 2px solid #0F70BC;
  color: #FFFFFF;
  text-align: center;
  margin-right: 1rem;
`;

class EventFormDetailInfo extends Component {
  saveAndContinue = e => {
    e.preventDefault();
    this.props.nextStep(2);
  };
  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const {
      values,
      translate,
      activeLanguage,
      createEventPermission,
      sponsorUploadTrigger,
      user
    } = this.props;

    const roundsOption = [
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 }
    ];

    const payoutAccRegionOptions = [
      { label: 'CA, CAD', value: 'CA' },
      { label: 'US, USD', value: 'US' }
    ];

    const tagOptions = [
      { value: '5G', label: '5G' },
      { value: 'Design', label: 'Design' },
      { value: 'IoT', label: 'IoT' },
      { value: 'Education', label: 'Education' },
      { value: 'Tool', label: 'Tool' },
      { value: 'Blockchain', label: 'Blockchain' },
      { value: 'STEM', label: 'STEM' },
      { value: 'Medical', label: 'Medical' },
      { value: 'AI', label: 'AI' }
    ];

    const renderRoundsSubmissionDeadline = () => {
      const roundsFields = [];
      if (!values.rounds || values.rounds === 1 || values.rounds === 0) {
        roundsFields.push(
          <Form.Field name='rounds-deadline' key={`deadline-${values.rounds}`}>
            <FieldsHeader>
              <FieldsOrderNumber>13</FieldsOrderNumber>
              <FieldsHeaderText>Round 1 {translate('eventAdmin.eventDetailEdit.submissionDeadline')}</FieldsHeaderText>
            </FieldsHeader>
            <FieldsContent>
              <Field
                name='subDeadline'
                component={HHDatePicker}
                otherProps={{
                  id: 'form-subDeadline',
                  locale: activeLanguage.code,
                  minDate: moment(values.start),
                  placeholderText: translate('selectEventSubDeadline')
                }}
              />
            </FieldsContent>
          </Form.Field>
        );
        return roundsFields;
      }
      for (let i = 1; i <= values.rounds; i += 1) {
        roundsFields.push(
          <Form.Field name='rounds-deadline' key={`deadline-${i}`}>
            <FieldsHeader>
              <FieldsOrderNumber>{12 + i}</FieldsOrderNumber>
              <FieldsHeaderText>
                Round {i} {translate('eventAdmin.eventDetailEdit.submissionDeadline')}
              </FieldsHeaderText>
            </FieldsHeader>
            <FieldsContent>
              <Field
                name={'round'.concat(String(i)).concat('Deadline')}
                component={HHDatePicker}
                otherProps={{
                  id: 'form-roundsDeadline'.concat(String(i)),
                  locale: activeLanguage.code,
                  placeholder: translate('selectEventSubDeadline')
                }}
              />
            </FieldsContent>
          </Form.Field>
        );
      }
      return roundsFields;
    };

    return (
      <div className='create-event-container'>
        <CreateEventQuitModal />
        <Form className='cms-create-event-form' id='more-detail'>
          <div className='ui two column grid'>
            <div className='column main dateTime'>
              <FormHeader>
                {translate('createEvent.form.header.detail')}
              </FormHeader>
              <FormSubHeader>
                {translate('createEvent.form.subHeader.themesNSettings')}
              </FormSubHeader>
              <section className='section'>
                <Form.Field name='position-tags'>
                  <FieldsHeader>
                    <FieldsOrderNumber>7</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('pleaseChooseTheme')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent
                    data-cy-test-id='themeSelector'
                  >
                    <Field
                      name='tags'
                      component={ThemeMultipleSelect}
                      otherProps={{
                        id: 'tags',
                        options: tagOptions,
                        creatable: true,
                        placeholder: translate('chooseTheme'),
                        required: true
                      }}
                    />
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field>
                  <FieldsHeader>
                    <FieldsOrderNumber>8</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventPaidFree')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <FieldsHelpText>{translate('eventPaidFreeInstruction')}</FieldsHelpText>
                    <Field name='type' component={HHSingleSelectLightBtn} />
                  </FieldsContent>
                </Form.Field>
              </section>
              {values.type === 'TICKET' &&
                <section className='section'>
                  <Form.Field>
                    <FieldsHeader>
                      <FieldsOrderNumber>8.1</FieldsOrderNumber>
                      <FieldsHeaderText>
                        {translate('eventAdmin.eventDetailEdit.selectPayoutAccRegion')}
                      </FieldsHeaderText>
                    </FieldsHeader>
                    <FieldsContent>
                      <Field
                        name='payoutAccRegion'
                        component={HHSingleSelect}
                        otherProps={{
                          id: 'form-payoutAccRegion',
                          simpleValue: true,
                          searchable: false,
                          clearable: false,
                          options: payoutAccRegionOptions,
                          placeholder: translate('eventAdmin.eventDetailEdit.selectPayoutAccRegion')
                        }}
                      />
                    </FieldsContent>
                  </Form.Field>
                </section>
                }
              <section className='section'>
                <Form.Field name='position-isPrivate'>
                  <FieldsHeader>
                    <FieldsOrderNumber>9</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventPublic')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <FieldsHelpText>{translate('eventPublicInstruction')}</FieldsHelpText>
                    {createEventPermission ? (
                      <Field name='isPrivate' component={HHSingleSelectLightBtn} />
                    ) : (
                      <Field name='isNotWillingToPublic' component={HHSingleSelectLightBtn} />
                    )}
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field name='position-isScreening'>
                  <FieldsHeader>
                    <FieldsOrderNumber>10</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventNeedScreen')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <FieldsHelpText>{translate('eventApplicationNote')}</FieldsHelpText>
                    <Field name='isScreening' component={HHSingleSelectLightBtn} />
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field name='position-containStreaming'>
                  <FieldsHeader>
                    <FieldsOrderNumber>11</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventNeedStreaming')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <Field name='containStreaming' component={HHSingleSelectLightBtn} />
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field name='position-rounds'>
                  <FieldsHeader>
                    <FieldsOrderNumber>12</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('createEvent.form.fields.multiRounds')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <Field
                      name='rounds'
                      component={HHSingleSelect}
                      otherProps={{
                        id: 'form-competitionRounds',
                        simpleValue: true,
                        searchable: false,
                        clearable: false,
                        options: roundsOption,
                        placeholder: translate('eventAdmin.eventDetailEdit.selectRoundsPlaceHolder')
                      }}
                    />
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                { renderRoundsSubmissionDeadline() }
              </section>
            </div>
            <div className='column main moreDetail'>
              <FormSubHeader>
                {translate('createEvent.form.subHeader.eventDetail')}
              </FormSubHeader>
              <Form.Field>
                <section id='moreInfoColumn'>
                  <div
                    className='eventDetail_main cms-container'
                    id='moreInfoInput'
                  >
                    <div
                      className='eventDetail_main_detail empty'
                    >
                      <FieldsHelpText>{translate('eventMoreInfoInstruction')}</FieldsHelpText>
                      <Field
                        name='contentJson' activeLanguage={activeLanguage} component={HHContentEditor}
                        userToken={user.token && user.token}
                        fileType='event_description'
                        slug={values.slug}
                      />
                    </div>
                  </div>
                </section>
              </Form.Field>
              <section>
                <Form.Field>
                  <FormSubHeader> {translate('eventSponsors')}</FormSubHeader>
                  <FieldsHelpText>
                    {translate('cover.image.instruction')}
                  </FieldsHelpText>
                  <Field
                    name='sponsor'
                    component={HHFileUploader}
                    otherProps={{
                        id: 'form-sponsors',
                        // type: 'image_16x9',
                        type: 'image',
                        fileType: 'event_sponsor_images',
                        slug: values.slug,
                        userToken: user.token,
                        ele: values.sponsor.length,
                        trigger: (
                          <Image
                            id='sponsorImgTrigger'
                            src={sponsorUploadTrigger}
                            alt='uploaded file'
                          />
                        )
                      }}
                  />
                </Form.Field>
                <Form.Field >
                  {values.sponsor.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {
                      values.sponsor.map((sponsor, idx) => (
                        <div style={{ margin: '1rem' }} key={`sponsor-img-${idx}`}>
                          <Field
                            name='sponsor'
                            component={HHFileUploader}
                            otherProps={{
                              id: 'form-sponsor',
                              // type: 'image_16x9',
                              type: 'image',
                              fileType: 'event_sponsor_images',
                            slug: values.slug,
                            userToken: user.token,
                              ele: idx,
                              trigger: (
                                <Image
                                  id={`sponsorImgTrigger-${idx}`}
                                  src={values.sponsor[idx]}
                                  alt='uploaded file'
                                />
                              )
                            }}
                          />
                        </div>
                      ))
                    }
                  </div>
                  )}
                </Form.Field>
              </section>
              <br />
              <div className='prevBtn'>
                <Button onClick={this.back}>
                  {translate('createEvent.backBtn.detail')}
                </Button>
              </div>
              <div className='nextBtn'>
                <Button onClick={this.saveAndContinue}>
                  {translate('createEvent.nextBtn.detail')}
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default withLocalize(EventFormDetailInfo);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormDetailInfo.js